export function updateCurrentHadLiveChatCookieValue(value) {
    const props = {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        CookieName: "hadLiveChat=",
        Type: value,
    };
    if (doesHadLiveChatCookieExist() === false) {
        setCurrentHadLiveChatCookieValue(props);
    }
    else {
        if (getCurrentHadLiveChatCookieValue() !== value) {
            setCurrentHadLiveChatCookieValue(props);
        }
    }
}
function doesHadLiveChatCookieExist() {
    const cookieName = "hadLiveChat=";
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return true;
        }
    }
    return false;
}
export function getCurrentHadLiveChatCookieValue() {
    const cookieName = "hadLiveChat=";
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return currentFocusedCookie.substring(cookieName.length + 1, currentFocusedCookie.length);
        }
    }
    return "false";
}
export function setCurrentHadLiveChatCookieValue(props) {
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(cookieExpirationDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    const expireTime = "expires=" + cookieExpirationDate.toUTCString();
    if (props.Type === "true") {
        document.cookie = props.CookieName + "true" + ";" + expireTime + ";path=/";
    }
    else if (props.Type === "false") {
        document.cookie = props.CookieName + "false" + ";" + expireTime + ";path=/";
    }
}
export function deleteCurrentHadLiveChatCookie() {
    document.cookie = "hadLiveChat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
